export var HistoryPeriodEnumKeys;
(function (HistoryPeriodEnumKeys) {
    HistoryPeriodEnumKeys["ONE_DAY"] = "ONE_DAY";
    HistoryPeriodEnumKeys["ONE_WEEK"] = "ONE_WEEK";
    HistoryPeriodEnumKeys["ONE_MONTH"] = "ONE_MONTH";
    HistoryPeriodEnumKeys["THREE_MONTHS"] = "THREE_MONTHS";
    HistoryPeriodEnumKeys["SIX_MONTHS"] = "SIX_MONTHS";
    HistoryPeriodEnumKeys["ONE_YEAR"] = "ONE_YEAR";
    HistoryPeriodEnumKeys["CURRENT_YEAR"] = "CURRENT_YEAR";
})(HistoryPeriodEnumKeys || (HistoryPeriodEnumKeys = {}));
export const historyPeriodLabelsInDays = {
    [HistoryPeriodEnumKeys.ONE_DAY]: 'time_one_day',
    [HistoryPeriodEnumKeys.ONE_WEEK]: 'time_one_week_in_days',
    [HistoryPeriodEnumKeys.ONE_MONTH]: 'time_one_month_in_days',
    [HistoryPeriodEnumKeys.THREE_MONTHS]: 'time_three_month_in_days',
    [HistoryPeriodEnumKeys.SIX_MONTHS]: 'time_six_month',
    [HistoryPeriodEnumKeys.ONE_YEAR]: 'time_one_year_in_days',
    [HistoryPeriodEnumKeys.CURRENT_YEAR]: 'time_current_year',
};
//# sourceMappingURL=period.js.map